import { DatePicker, Form } from 'antd';
import { FormInstance } from 'antd/es/form/hooks/useForm';
import dayjs, { Dayjs } from 'dayjs';
import { useTranslation } from 'translations/hooks';

import { UpdateSegmentFormValues } from './types';

interface UpdateSegmentFormProps {
  form: FormInstance<UpdateSegmentFormValues>;
  save: (row: UpdateSegmentFormValues) => void;
  initialValues: UpdateSegmentFormValues;
}

export const UpdateSegmentForm: React.FC<UpdateSegmentFormProps> = ({
  form,
  save,
  initialValues,
}) => {
  const { t } = useTranslation();

  const disabledDate = (current: Dayjs) => {
    return current && current > dayjs().tz().endOf('day');
  };

  return (
    <Form<UpdateSegmentFormValues>
      form={form}
      layout="vertical"
      onFinish={save}
      initialValues={initialValues}
    >
      <Form.Item<UpdateSegmentFormValues>
        name="date"
        label={t('qualityControl.segmentHistory.editModal.date')}
        rules={[{ required: true }]}
      >
        <DatePicker
          style={{ width: '100%' }}
          showTime={{ format: 'HH:mm' }}
          format="L HH:mm"
          allowClear={false}
          disabledDate={disabledDate}
        />
      </Form.Item>
    </Form>
  );
};
